import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { ClinicService } from '@mmx/shared'

@Component({
  selector: 'mmx-intake-code-dialog-component',
  templateUrl: './intake-code-dialog.component.html',
  styleUrls: ['./intake-code-dialog.component.scss'],
  standalone: false,
})
export class IntakeCodeDialogComponent {
  public get qrImage() {
    const link = encodeURIComponent(
      `https://${this.clinicService.clinic.slug}.patientpal.com/code?code=${this.data.code}`,
    )
    return `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${link}`
  }

  constructor(
    public clinicService: ClinicService,
    public dialogRef: MatDialogRef<IntakeCodeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}
}
